import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";

function LanguageHandler() {
  const location = useLocation();
  useEffect(() => {
    // English only on explicit /en-prefixed paths or known English-only routes
    // Root "/" redirects to "/es", so Spanish is the effective default
    const isEnglish = !location.pathname.startsWith('/es') && location.pathname !== '/';
    const targetLang = isEnglish ? 'en' : 'es';
    if (i18n.language !== targetLang) i18n.changeLanguage(targetLang);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageHandler />
        <AppRoutes />
        <FloatingWhatsApp />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
